export default __webpack_public_path__ + "static/media/heraldofxotli.ea7068f8.png";